<template>
    <div class="relative">
      <AppHeader />
      <!--AppDetails v-if="product" :product-data="product" /-->
      <div v-if="product && displayProduct" class="z-50 top-0 left-0 w-full h-full fixed overflow-y-scroll">
        <product-page @displayProductPage="displayProductPage" :product="product" />
      </div>
      <AppFilter @category_slug="getProducts"/>
      <div class="flex flex-wrap" v-if="products.length">
            <div 
                v-for="(product, index) in products.slice(start_product,end_product)" 
                :key="product.slug" 
                :style="{backgroundColor:getColor(index)}"
                :id="product.slug"
                @click="productDetails(product)"
                class="product-item flex justify-center flex-col py-14 md:py-0 w-full sm:w-6/12 md:w-4/12 xl:w-3/12 px-8"
                >

                <!--router-link :product="product" class="detail-link" :to="{
                    name: 'AppDetails', 
                    params: {slug: product.slug, product:product.id}
                    }"
                    -->
                    <v-lazy-image v-bind:src="product.img_name" class="mx-auto" />
                    <div class="product-reference">{{ product.reference }}</div>
                <!--/router-link-->
            </div>
      </div>
      <div v-else>
        <NotFound />
      </div>
    </div>
</template>

<script>

    import VLazyImage from "v-lazy-image" 
    // import ProductService from '../services/ProductService'
    import AppFilter from "../components/AppFilter.vue"
    import AppHeader from '../components/SmcHeader.vue'
    import store from '@/store/index'
    import NotFound from "@/views/Errors/NotFound";
    //import appDetails from "@/views/AppDetails.vue";
    import ProductPage from "@/views/productPage.vue";
    // import { mapGetters } from 'vuex'

    export default {
      components: {
        ProductPage,
        NotFound,
        VLazyImage,
        AppFilter,
        AppHeader,
        //appDetails
      },
      props:{
        fromHome:{
          type:Boolean,
          require:true
        }
      },
        data() {
            return {
                test:1,
                displayProduct:false,
                product: null,
                products: [],
                temp_color : [],
                start : 0,
                end_product: 24,
                page:1,
                colors:[
                    '#5F4433', 
                    '#E16600', 
                    '#F39300', 
                    '#FFCE00', 
                    '#F39300', 
                    '#5F4433', 
                    '#B29149', 
                    '#E16600',
                    '#B29149',
                    '#FFCE00',
                    '#F39300',
                    '#fece00'
                ]
            }
        },
        methods: {
            async productDetails(product) {
                console.log(product.slug)
                await store.dispatch('showProduct', true)
                await store.dispatch('getProductBySlug', product.slug)
                    .then(response => {
                        this.product = response.data
                        console.log('produit search')
                        console.log(this.product)
                        this.displayProduct = store.getters.displayProduct
                        return response
                    })
            },
            displayProductPage(value) {
                this.displayProduct = value
            },
            getRandomColor(){
                return this.colors[Math.floor(Math.random()*this.colors.length)]
            },
            async getProducts(category_slug){
                this.products = []
                await store.dispatch('fetchProductsCategories', {slug: category_slug})
                this.products = store.getters.getProducts
            },
            getColor(index){
                return this.colors[index%13]
            },

            /**
             * Get nex products on scroll.
             */
            getNextProducts() {
                window.onscroll = () => {
                    let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - 40;
                    if ( bottomOfWindow ) {
                        if(this.page <= this.totalPages()){
                            this.end_product = this.end_product + 24
                        }
                        this.page ++;
                    }
                }
            },

            /**
             * Get total pages.
             * @return integer
             */
            totalPages() {
                let total = Math.ceil(this.products.length / 24);
                return total;
            }
        },
        created() {
          store.dispatch('fetchProducts')
            console.log('fetch')
          const products = store.getters.getProducts
            if(products && products.length > 0) {
                this.products = products.sort(() => 0.5 - Math.random())
            }

        },
        computed: {
            productsData () {
                return store.state.products
            },
            colorsLength(){
                return this.colors.length
            }
            
        },
        mounted() {
            this.getNextProducts();
        },
        watch: {
            productsData(newProducts, oldProducts){
                let p = []
                newProducts.forEach(newProduct => {
                    const exists = oldProducts.find( (product) => product.id === newProduct.id )
                    if(!exists){
                        p.push(newProduct)
                    }
                });
                this.products = newProducts
            },
            displayProduct(newState, oldState) {
                console.log(newState)
                console.log(oldState)
            }
        }
        
    }
</script>
<style scoped>
    
    .product-item {
        cursor: pointer;
    }
     .v-lazy-image {
        opacity: 0;
        transition: opacity 2s;
    }
    .v-lazy-image-loaded {
        opacity: 1;
    }
    .product-item img {
        width: 80%;
        max-width: 237px;
    }
    @media(min-width: 980px){
        .product-item {
            height: 436px;
        }
    }
    
</style>